module.exports = __webpack_public_path__ + "media/images/telephone-icon-dca14806ccca78cf85ae541e2b3bd4a2.svg";